import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'project_status',
})
export class StatusPipe implements PipeTransform {
    transform(type: number) {
        if(type == -1) {
            return "Inactive"
        }
        else if (type == 0 || type == 2) {
            return 'Active'
        } else if (type == 1) {
            return 'Completed'
        } else if (type == 21) {
            return 'Awaiting Missing Info'
        }
        return type
    }
}
